<template>
  <div>
    <!-- 第一部分 -->
    <div class="banner">
      <img
        src="https://xiaomeng-card-prod.oss-cn-shenzhen.aliyuncs.com/prod/0/0/169140364008272.jpg"
        alt=""
        style="vertical-align: middle; width: 100%"
      />
    </div>

    <div class="first_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">公司简介</span>
              <span class="title_en"> Company Introduction </span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex j-center">
        <div style="width: 1200px; text-align: left">
          <p style="font-size: 20px; color: #333; line-height: 1.75em">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;德国Tetra德彩水族有限公司是全球最大的水族生产商和供应商，总部在德国的Melle,在美国，欧洲各国，
            日本和亚洲都设有分公司，全球超过90个国家和地区在销售Tetra德彩的水族产品。<br/>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;至今，Tetra德彩公司已经超过70年，其推出的全球第一种工业化生产的营养均衡的观赏鱼薄片饲料TetraMin给整个观赏鱼行业带来了革命性的改变。<br/>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Tetra德彩公司持续不断和全球先进的水族馆和海洋馆合作，对水族产品进行研究，以推动自然资源的保护。而Tetra德彩公司的生物学家，化学家和营养学家每天在Tetra德彩观赏鱼研究中心对超过900个鱼缸近25000条各种观赏鱼进行实验，测试和分析，目的就是为了使观赏鱼等水生生物更健康快乐的生活。
          </p>
        </div>
      </div>
    </div>

<!-- 第二部分 -->
<div class="second_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">公司起源</span>
              <span class="title_en"> Company Origin</span>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-bottom: 40px;" class="w">
      <img
        src="https://xiaomeng-card-prod.oss-cn-shenzhen.aliyuncs.com/prod/0/0/169140374111971.jpg"
        alt=""
        style="vertical-align: middle; width: 100%"
      />
    </div>
      <!-- 正文 -->
      <div class="w d-flex j-center">
        <div style="width: 1200px; text-align: left">
          <p style="font-size: 20px; color: #333; line-height: 1.75em">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;半个世纪前，青年科学家Ulrich Baensch博士给观赏鱼饲养爱好者带来的革命性的改变，而当时饲养观赏鱼是非常困难和麻烦的事。
            Ulrich Baensch博士1951年在德国的汉诺威饲养热带鱼，当时全德国约有50,000个热带鱼饲养者，由于要从小溪和河床捕获活饵作为饲料，因此是一项耗时和麻烦的爱好。
            当Ulrich Baensch博士发明一种用于喂食热带鱼的薄片饲料时，这一爱好就发生了巨大的变化。<br/>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;TetraMin 是在1951年发明的，它包含了四种不同的添加了维他命的薄片。Tetra是希腊文四的意思，而Min是维他命第三音节的发音。所以该革命性的薄片饲料就被命名为TetraMin。
          </p>
        </div>
      </div>
    </div>

    <!-- 第三部分 -->
<div class="first_part">
    <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">德彩产品线</span>
              <span class="title_en">Product Line of Tetra</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex j-center">
        <div style="width: 1200px; text-align: left">
          <p style="font-size: 20px; color: #333; line-height: 1.75em">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Tetra德彩公司生产的数百种系列完整品质卓著的水族产品包括有：水族饲料系列，水质处理系列，水草系列，药品系列以及器材系列等。<br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;使用Tetra德彩系列产品，水族爱好者能简单轻松的照顾好心爱的水族缸，给生活添加美好的情趣。因为Tetra德彩，水族饲养者超越了爱好，是一种热爱。
          </p>
        </div>
      </div>
      <div style="margin-top: 40px;" class="w">
      <img
        src="https://xiaomeng-card-prod.oss-cn-shenzhen.aliyuncs.com/prod/0/0/1691403787551112.jpg"
        alt=""
        style="vertical-align: middle; width: 100%"
      />
    </div>
    </div>

<!-- 第四部分 -->
<div class="second_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">热带鱼饲料系列</span>
              <span class="title_en">七彩神仙颗粒饲料</span>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-bottom: 40px;" class="w d-flex j-center">
      <div style="width: 500px;">
        <img
        src="https://xiaomeng-card-prod.oss-cn-shenzhen.aliyuncs.com/prod/0/0/169154854877025.jpg"
        alt=""
        style="vertical-align: middle; width: 100%"
      />
      </div>
    </div>
      <!-- 正文 -->
      <div class="w d-flex j-center">
        <div style="width: 800px; text-align: left">
          <p style="font-size: 20px; color: #333; line-height: 1.75em">
         <strong style="font-size: 30px;color: #2963A4;"> 产品卖点：</strong><br>
根据七彩神仙的营养需求和进食习惯而特别研究的高品质的颗粒饲料。
· 缓沉的红色颗粒。<br>
· 绝不可能发生喂食天然食品时而出现的疾病传播。<br>
· 适合七彩神仙特殊营养需求的最优化选择，充分考虑其颜色及体形。<br>
· 包含所有重要营养物质如维他命、微量元素，营养均衡和浓缩。<br>
· 饲料缓慢沉入水族缸底，符合七彩鱼的典型进食心惯。<br>
· 含稳定型的维他命C，可以增强对疾病的抵抗力，促进健康成长和避免营养缺乏症候群产生和天然食品相比，该饲料避免了由病菌引起的传染<br>
· 嗜口性，因此容易被七彩神仙很好接受<br>
· 容易消化<br>
· 不浑浊水质<br><br>

<strong style="font-size: 30px;color: #2963A4;"> 喂食说明：</strong><br>
· 也可喂食在中层生活的热带鱼类：如天使鱼、小丽鱼、各种末成年的丽鱼<br><br>

<strong style="font-size: 30px;color: #2963A4;"> 包装规格：</strong><br>
· 100ml/30g, 250ml/52g, 1L/300g
          </p>
        </div>
      </div>
    </div>
    
<!-- 第四部分 -->
<div class="first_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">热带鱼饲料系列</span>
              <span class="title_en">慈鲷科条状饲料</span>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-bottom: 40px;" class="w d-flex j-center">
      <div style="width: 500px;">
        <img
        src="https://xiaomeng-card-prod.oss-cn-shenzhen.aliyuncs.com/prod/0/0/169154869263722.jpg"
        alt=""
        style="vertical-align: middle; width: 100%"
      />
      </div>
    </div>
      <!-- 正文 -->
      <div class="w d-flex j-center">
        <div style="width: 800px; text-align: left">
          <p style="font-size: 20px; color: #333; line-height: 1.75em">
         <strong style="font-size: 30px;color: #2963A4;"> 产品卖点：</strong><br>
         主要为慈鲷科鱼，尤其是“花牛角”和“罗汉”而设计的饲料。
         · 包含高比例的动物蛋白和植物营养物质。<br>
         · 绝不可能发生喂食天然食品时而出现的疾病传播。<br>
         · 该营养配方通过其中特制的氨基酸成分满足慈鲷科鱼对蛋白质的需求，并促进鱼类自然成型。<br>
         · 条状的形状是根据大型鱼的嘴的形状而设计。条型饲料符合了鱼类进食习惯，而且它们浮于水面。<br>
         · 包含所有必不可少的营养物质，维他命和微量元素。<br>
         · 促进自然体色增色。<br>
         · 容易被慈鲷科鱼和其他大型鱼如“花牛角”和“罗汉”接受。<br>
         · 易于消化。<br><br>

<strong style="font-size: 30px;color: #2963A4;"> 喂食说明：</strong><br>
· 每天喂四次，确保放入饲料量可让鱼儿在5分钟内摄食完毕，该饲料营养丰富，所以要避免多喂食。<br><br>

<strong style="font-size: 30px;color: #2963A4;"> 包装规格：</strong><br>
· Tetra德彩慈鲷科饲料 250ml/75克，Tetra德彩罗汉增艳起头饲料  250ml/1L。
          </p>
        </div>
      </div>
    </div>

<!-- 第五部分 -->
<div class="second_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro"> 冷水鱼饲料系列</span>
              <span class="title_en">Tetra德彩金鱼金牌主食饲料</span>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-bottom: 40px;" class="w d-flex j-center">
      <div style="width: 500px;">
        <img
        src="https://xiaomeng-card-prod.oss-cn-shenzhen.aliyuncs.com/prod/0/0/169154873944457.jpg"
        alt=""
        style="vertical-align: middle; width: 100%"
      />
      </div>
    </div>
      <!-- 正文 -->
      <div class="w d-flex j-center">
        <div style="width: 800px; text-align: left">
          <p style="font-size: 20px; color: #333; line-height: 1.75em">
         <strong style="font-size: 30px;color: #2963A4;"> 产品卖点：</strong><br>
         专门针对珍贵金鱼的营养需求而设计。
         · 是珍贵金鱼如：狮子头　镏金的理想选择。<br>
         · 含有优质的植物成份如精选的小麦胚芽。<br>
         · 优良的配方保证营养物质的高度利用。<br>
         · 高含量的粗制饲料有助于避免产生消化问题，悬浮状的饲料非常迅速地软化，所以鱼类可以容易从水面进食。<br><br>

<strong style="font-size: 30px;color: #2963A4;"> 喂食说明：</strong><br>
· 放入鱼类可在5分钟内吃完的饲料量，每天三次。<br><br>

<strong style="font-size: 30px;color: #2963A4;"> 包装规格：</strong><br>
·  250ml。
          </p>
        </div>
      </div>
    </div>

<!-- 第六部分 -->
<div class="first_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro"> 冷水鱼饲料系列</span>
              <span class="title_en">Tetra德彩池塘锦鲤条状饲料</span>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-bottom: 40px;" class="w d-flex j-center">
      <div style="width: 500px;">
        <img
        src="https://xiaomeng-card-prod.oss-cn-shenzhen.aliyuncs.com/prod/0/0/169154878925250.jpg"
        alt=""
        style="vertical-align: middle; width: 100%"
      />
      </div>
    </div>
      <!-- 正文 -->
      <div class="w d-flex j-center">
        <div style="width: 800px; text-align: left">
          <p style="font-size: 20px; color: #333; line-height: 1.75em">
         <strong style="font-size: 30px;color: #2963A4;"> 产品卖点：</strong><br>
         根据锦鲤的营养需求而特别研制。
         · 含有长期稳定型的维他命C<br>
         · 含有自然增色物质（类胡萝卜素），可以让鱼类展现红色，黄色和橙色的光泽。<br>
         · 漂浮的条状饲料是根据池塘条件而专门设计的，使条状饲料不会因为发臭或被风吹散而浪费。<br>
         · 已经证实，Tetra德彩高品质的锦鲤条状饲料易于消化。<br>
         · 特高的蛋白质含量促进年幼锦鲤的成长。<br>
         · 均衡的脂肪和蛋白含量，锦鲤可吸收优良营养。<br>
         · 每天饲喂相当于体重1.5%的饲料就足以保持鱼类活力和健康（竞争饲料则需要5%）<br>
         · 排泄物少，因此污染小。<br>
         · 至少两年的保质期。<br>
          </p>
        </div>
      </div>
    </div>

    <!-- 第七部分 -->
<div class="second_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">  海水鱼饲料系列</span>
              <span class="title_en">Tetra德彩海水鱼颗粒饲料</span>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-bottom: 40px;" class="w d-flex j-center">
      <div style="width: 500px;">
        <img
        src="https://xiaomeng-card-prod.oss-cn-shenzhen.aliyuncs.com/prod/0/0/1691548817976131.jpg"
        alt=""
        style="vertical-align: middle; width: 100%"
      />
      </div>
    </div>
      <!-- 正文 -->
      <div class="w d-flex j-center">
        <div style="width: 800px; text-align: left">
          <p style="font-size: 20px; color: #333; line-height: 1.75em">
         <strong style="font-size: 30px;color: #2963A4;"> 产品卖点：</strong><br>
         Tetra德彩海水鱼颗粒饲料是适合中型海水鱼的饲料，它是红色和绿色的颗料。<br>
         · 这种饲料包含许多从来自海洋如藻类小虾和螃蟹的原材料，这种饲料还添加了稳定型维他命C，
         颗粒缓慢下沉，可以让生活在中间和底层的鱼类易于摄取。<br>
         · 它可强烈促进所有海水鱼的成长，活动以及颜色艳丽。<br><br>

<strong style="font-size: 30px;color: #2963A4;"> 喂食说明：</strong><br>
· 放入鱼类可在3分钟摄食完的饲料，每天三次。通过观察鱼类进食而避免超量饲喂。<br><br>

<strong style="font-size: 30px;color: #2963A4;"> 包装规格：</strong><br>
· 500ml/225g, 1L/450g。
          </p>
        </div>
      </div>
    </div>
    <!-- 第八部分 -->
<div class="first_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">  爬行动物饲料系列</span>
              <span class="title_en">Tetra德彩龟/两栖爬虫饲料(条状)</span>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-bottom: 40px;" class="w d-flex j-center">
      <div style="width: 500px;">
        <img
        src="https://xiaomeng-card-prod.oss-cn-shenzhen.aliyuncs.com/prod/0/0/1691548838666102.jpg"
        alt=""
        style="vertical-align: middle; width: 100%"
      />
      </div>
    </div>
      <!-- 正文 -->
      <div class="w d-flex j-center">
        <div style="width: 800px; text-align: left">
          <p style="font-size: 20px; color: #333; line-height: 1.75em">
         <strong style="font-size: 30px;color: #2963A4;"> 产品卖点：</strong><br>
         · 健康、美味的两栖爬虫龟喂食饲料，适用于水龟等爬行动物<br>
         · 含有所有必要的成分，适合龟的饮食需求<br>
         · 最佳钙含量有助于外壳的健康形成和骨骼的强壮生长<br>
         · 含有高比例、易消化的蛋白质<br><br>

<strong style="font-size: 30px;color: #2963A4;"> 喂食说明：</strong><br>
· 每天两次，可在3至5分钟摄食完的饲料。通过观察鱼类进食而避免超量饲喂。<br><br>

<strong style="font-size: 30px;color: #2963A4;"> 包装规格：</strong><br>
· 100ml/22g;250ml/55g,500mL/110g。
          </p>
        </div>
      </div>
    </div>

        <!-- 底部栏 -->
        <foot></foot>

  </div>
</template>
<script>
import foot from '@/components/footer.vue'
export default {
    data() {
        return {
            
        }
    },
    components:{
    foot
  },
};
</script>
<style lang="scss" scoped>
.w {
  width: 1200px;
  margin: 0 auto;
}

.d-flex {
  display: flex;
}
.a-center {
  align-items: center;
}

.j-center {
  justify-content: center;
}
.banner {
  width: 100%;
}
.first_part {
  display: flex;
  justify-content: center;
  //   align-items: center;
  flex-direction: column;
  padding: 90px 0;
  background-color: #f4f7fb;
}

.title {
  width: 1200px;
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}
.titleBox {
  padding: 4px 0;
  //   border-bottom: 1px solid #2963a4;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  //   .title_num {
  //     font-size: 80px;
  //     font-weight: 500;
  //     color: #2963a4;
  //     margin-right: 5px;
  //   }
  .title_contain {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 10px 20px;
    border-bottom: 5px solid #2963a4;
    .title_intro {
      font-size: 46px;
      color: #333;
      font-weight: 600;
      text-align: center;
    }
    .title_en {
      font-size: 35px;
      letter-spacing: 0.02em;
      text-align: center;
      color: #999;
    }
  }
}

.second_part {
  display: flex;
  justify-content: center;
  //   align-items: center;
  flex-direction: column;
  padding: 90px 0;
  background-color: #fff;
}

.third_part {
  display: flex;
  justify-content: center;
  //   align-items: center;
  flex-direction: column;
  padding: 90px 0;
  background-color: #f4f7fb;
}
</style>